<form [formGroup]="form" (validSubmit)="editLink()">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ attachment ? 'Edit Link' : 'Add Link' }}
    </h4>
  </div>

  <div class="modal-body vertical align-items-stretch pb-0 form-section">
    <app-form-control [columnLayout]="true" size="full">
      <app-form-label [required]="true">Name</app-form-label>
      <div>
        <div>
          <input
            data-dd-action-name="edit-attachment-link-modal.file-name-input"
            placeholder="Link file name"
            class="form-control"
            formControlName="fileName"
            [class.is-invalid]="
              form.controls.fileName.touched && form.controls.fileName.invalid
            "
          />
          @if (form.controls.fileName.hasError('required')) {
            <div class="invalid-feedback">Name is required</div>
          }
        </div>
      </div>
    </app-form-control>
    <app-form-control [columnLayout]="true" size="full">
      <app-form-label [required]="true">URL</app-form-label>
      <div>
        <div>
          <input
            data-dd-action-name="edit-attachment-link-modal.link-input"
            placeholder="http or https"
            class="form-control"
            formControlName="externalStorageLink"
            [class.is-invalid]="
              form.controls.externalStorageLink.touched &&
              form.controls.externalStorageLink.invalid
            "
          />
          @if (form.controls.externalStorageLink.hasError('required')) {
            <div class="invalid-feedback">Link is required</div>
          }
          @if (
            form.controls.externalStorageLink.touched &&
            form.controls.externalStorageLink.hasError('pattern')
          ) {
            <div class="invalid-feedback">
              Link must start with http:// or https://
            </div>
          }
        </div>
      </div>
    </app-form-control>
  </div>
  <div class="modal-footer">
    <button
      data-dd-action-name="edit-attachment-link-modal.cancel-button"
      type="button"
      class="btn btn-outline"
      (click)="modal.dismiss('exit')"
    >
      Cancel
    </button>

    <button
      data-dd-action-name="edit-attachment-link-modal.save-button"
      type="submit"
      class="btn btn-primary me-2"
    >
      <i-lucide [name]="attachment ? 'save' : 'plus'"></i-lucide>
      {{ attachment ? 'Save' : 'Add' }}
    </button>
  </div>
</form>
